import {
  Button,
  Divider,
  Grid,
  Group,
  Image,
  Stack,
  Text,
  Title,
} from '@mantine/core'
import { Link } from '@remix-run/react'

export const Footer = () => {
  return (
    <Stack p='lg' gap='xl'>
      <Link to='/'>
        <Image
          style={{ maxWidth: '230px' }}
          radius='md'
          src='/logo.svg'
          alt={`シンアド就活${import.meta.env.VITE_PROJECT_YEAR}のロゴ画像`}
        />
      </Link>

      <Group justify='space-between'>
        <Stack gap='xl'>
          <Group w='100%'>
            <Stack justify='space-between' maw={{ xs: 120, sm: 240, md: 240 }}>
              <Title order={5} c='primary' fw='bold'>
                Webからのお問合せ
              </Title>
              <Grid w='100%'>
                <Grid.Col span={{ xs: 12, sm: 6 }}>
                  <Button
                    w={{ xs: '100%', sm: 'auto' }}
                    component={Link}
                    variant='light'
                    color='primary'
                    to='/contact/student'
                  >
                    就活生の方
                  </Button>
                </Grid.Col>
                <Grid.Col span={{ xs: 12, sm: 6 }}>
                  <Button
                    w={{ xs: '100%', sm: 'auto' }}
                    component={Link}
                    variant='filled'
                    color='primary'
                    to='/contact/company'
                  >
                    採用企業の方
                  </Button>
                </Grid.Col>
              </Grid>
            </Stack>
            <Divider orientation='vertical' color='primary' />

            <Stack justify='space-between'>
              <Title order={5} c='primary' fw='bold'>
                電話でのお問合せ
              </Title>
              <Stack gap='xs'>
                <Link to='tel:03-6277-5117'>
                  <Text fw='bold' size='xl' c='primary'>
                    03-6277-5117
                  </Text>
                </Link>
                <Title order={5} c='primary'>
                  平日10:00〜18:30
                </Title>
              </Stack>
            </Stack>
            <Divider orientation='vertical' color='primary' />
          </Group>

          <Grid hiddenFrom='sm' w='100%'>
            <Grid.Col span={6}>
              <Stack gap='xs'>
                <Text fw='bold' size='sm' c='primary'>
                  中途キャリア支援
                </Text>
                <Button
                  variant='outline'
                  component={Link}
                  to='https://lp.bizdigi.jp/'
                  target='_blank'
                >
                  <Image
                    style={{ maxWidth: '100px' }}
                    radius='md'
                    src='/logo_career.svg'
                    alt='シンアド転職のロゴ画像'
                  />
                </Button>
              </Stack>
            </Grid.Col>
            <Grid.Col span={6}>
              <Stack gap='xs'>
                <Text fw='bold' size='sm' c='primary'>
                  就活生の情報収集
                </Text>
                <Button
                  variant='outline'
                  component={Link}
                  to='https://syn-ad.com/senpai-shukatsu'
                  target='_blank'
                >
                  <Image
                    style={{ maxWidth: '125px' }}
                    radius='md'
                    src='/logo_magazine.svg'
                    alt='シンアドMAGAZINEのロゴ画像'
                  />
                </Button>
              </Stack>
            </Grid.Col>
          </Grid>

          <Group gap='md' hiddenFrom='md'>
            <Link to={import.meta.env.VITE_LINE_CHANNEL_URL} target='_blank'>
              <Image w={28} src='/line.png' alt='LINEアイコン' />
            </Link>

            <Link to='https://x.com/shinsotsu_ad' target='_blank'>
              <Image w={28} src='/x.png' alt='Xアイコン' />
            </Link>

            <Link
              to='https://www.instagram.com/synad_shukatsu/'
              target='_blank'
            >
              <Image w={28} src='/instagram.png' alt='Instagramアイコン' />
            </Link>
          </Group>

          <Group gap='xl'>
            <Stack gap='sm'>
              <Group px={0} gap='xs'>
                <Text
                  size='sm'
                  td='underline'
                  fw='bold'
                  component={Link}
                  to='https://inglewood.co.jp/'
                  target='_blank'
                >
                  運営会社
                </Text>
                <Text
                  size='sm'
                  td='underline'
                  fw='bold'
                  component={Link}
                  to='https://termhub.jp/view/term.html?k=zMR7TJu40s%2BarjnKCcua4wPtyY97xX%2FP%2BAznZqeW6vU%3D'
                  target='_blank'
                >
                  利用規約
                </Text>
                <Text
                  size='sm'
                  td='underline'
                  fw='bold'
                  component={Link}
                  to='https://termhub.jp/view/term.html?k=zMR7TJu40s%2BarjnKCcua4ymywv05%2Bn4DHZbModmVQDg%3D'
                  target='_blank'
                >
                  個人情報保護方針
                </Text>
                <Text
                  size='sm'
                  td='underline'
                  fw='bold'
                  component={Link}
                  to='https://termhub.jp/view/term.html?k=zMR7TJu40s%2BarjnKCcua42ZTGA2Hd9gosZCJiQX3fXM%3D'
                  target='_blank'
                >
                  取扱職種の範囲等の明示
                </Text>
              </Group>
              <Text size='xs' c='dimmed'>
                ©Inglewood CO.,LTD. All right reserved.
              </Text>
            </Stack>

            <Group gap='md' visibleFrom='md'>
              <Link to={import.meta.env.VITE_LINE_CHANNEL_URL} target='_blank'>
                <Image w={28} src='/line.png' alt='LINEアイコン' />
              </Link>

              <Link to='https://x.com/shinsotsu_ad' target='_blank'>
                <Image w={28} src='/x.png' alt='Xアイコン' />
              </Link>

              <Link
                to='https://www.instagram.com/synad_shukatsu/'
                target='_blank'
              >
                <Image w={28} src='/instagram.png' alt='Instagramアイコン' />
              </Link>
            </Group>
          </Group>
        </Stack>

        <Stack gap='xl' visibleFrom='sm'>
          <Stack gap='xs'>
            <Text fw='bold' size='sm' c='primary'>
              中途キャリア支援
            </Text>
            <Button
              size='md'
              variant='outline'
              component={Link}
              to='https://lp.bizdigi.jp/'
              target='_blank'
            >
              <Image
                style={{ width: '100px' }}
                radius='md'
                src='/logo_career.svg'
                alt='シンアド転職のロゴ画像'
              />
            </Button>
          </Stack>
          <Stack gap='xs'>
            <Text fw='bold' size='sm' c='primary'>
              就活生の情報収集
            </Text>
            <Button
              size='md'
              variant='outline'
              component={Link}
              to='https://syn-ad.com/senpai-shukatsu'
              target='_blank'
            >
              <Image
                style={{ width: '125px' }}
                radius='md'
                src='/logo_magazine.svg'
                alt='シンアドMAGAZINEのロゴ画像'
              />
            </Button>
          </Stack>
        </Stack>
      </Group>
    </Stack>
  )
}
